import { EditProfileForm } from "../../components/editProfileForm";
import { NavBar } from "../../components/navbar/navBar";

export function EditProfile() {
  return (
    <div className="ml-[19%]">
      <NavBar />
      <EditProfileForm />
    </div>
  );
}
